import React, { useContext, useState } from "react";
import FileSaver from "file-saver";
import { AppContext } from "../../context/AppContext";
import ApiConfig from "../../api/ApiConfig";
import { simpleGetCallWithErrorResponse } from "../../api/ApiServices";
import Loader from "../Loader";
import { ToastMsg } from "../TostMsg";
import { Card, Select, DownloadIconButton } from "../../components/ui";
import styles from "./HourlySalaryMusterRoll.module.scss";

const MONTHS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

const buildYearList = () => {
  const current = new Date().getFullYear();
  const years = [];
  for (let i = 0; i < 6; i++) years.push(current - i);
  return years;
};

const HourlySalaryMusterRoll = () => {
  const { sidebar } = useContext(AppContext);

  const now = new Date();
  const [filter, setFilter] = useState({
    month: now.getMonth() + 1,
    year: now.getFullYear(),
  });
  const [excelLoading, setExcelLoading] = useState(false);

  const yearList = buildYearList();
  const selectedMonthLabel =
    MONTHS.find((m) => m.value === filter.month)?.label || filter.month;

  const downloadHourlyReport = () => {
    setExcelLoading(true);
    const url =
      ApiConfig.GET_HOURLY_ATTENDANCE_REPORT +
      `?month=${filter.month}&year=${filter.year}`;

    simpleGetCallWithErrorResponse(url)
      .then((res) => {
        if (res?.json?.Success && res.json.Data?.FileContents) {
          FileSaver.saveAs(
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
              res.json.Data.FileContents,
            `Hourly_Salary_Muster_Roll_${selectedMonthLabel}_${filter.year}.xlsx`
          );
          ToastMsg(
            "success",
            res.json.Message || "Hourly Attendance Report generated successfully"
          );
        } else {
          ToastMsg("error", res?.json?.Message || "Failed to generate report");
        }
      })
      .catch(() => {
        ToastMsg("error", "Something went wrong");
      })
      .finally(() => setExcelLoading(false));
  };

  return (
    <div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
    >
      <div className={styles.page}>
        <div className={styles.header}>
          <h6 className={styles.title}>Hourly Salary Muster Roll</h6>
        </div>

        <div className={styles.toolbar}>
          <div className={styles.filters}>
            <Select
              id="hourly-year"
              label="Year"
              className={styles.filterField}
              value={filter.year}
              onChange={(e) =>
                setFilter((prev) => ({
                  ...prev,
                  year: Number(e.target.value),
                }))
              }
            >
              {yearList.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </Select>

            <Select
              id="hourly-month"
              label="Month"
              className={styles.filterField}
              value={filter.month}
              onChange={(e) =>
                setFilter((prev) => ({
                  ...prev,
                  month: Number(e.target.value),
                }))
              }
            >
              {MONTHS.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </Select>
          </div>

          <div className={styles.actions}>
            <DownloadIconButton
              size="md"
              variant="solid"
              tooltip="Download Hourly Salary Muster Roll"
              loading={excelLoading}
              disabled={excelLoading}
              onClick={downloadHourlyReport}
            />
          </div>
        </div>

        <Card padding="lg" elevation="sm">
          <h6 className={styles.sectionTitle}>Report Period</h6>
          <div className={styles.divider} />

          <div className={styles.summaryGrid}>
            <div className={styles.summaryItem}>
              <span className={styles.summaryLabel}>Month</span>
              <span className={styles.summaryValue}>{selectedMonthLabel}</span>
            </div>
            <div className={styles.summaryItem}>
              <span className={styles.summaryLabel}>Year</span>
              <span className={styles.summaryValue}>{filter.year}</span>
            </div>
          </div>

          <p className={styles.helperText}>
            Pick the month and year above and click the download icon to export
            the Hourly Salary Muster Roll as an Excel file.
          </p>
        </Card>

        {excelLoading && <Loader />}
      </div>
    </div>
  );
};

export default HourlySalaryMusterRoll;
